import { FC } from 'react'

import ColorField from './Color'
import FileField from './File'
import MarkdownField from './Markdown'
import TagsField from './Tags'
import MetadataField from './Metadata'
import LayoutField from './Layout'
import AstonishEmailTemplateSelectField from './AstonishEmailTemplateSelect'

import {
  FormFieldProps,
} from '@kaidam/fc-shared/src/types/frontend/form'

import baseFields, { defaultValues as baseDefaultValues } from '@kaidam/fc-shared/src/frontend/components/form/fields'

const fields: Record<string, FC<React.PropsWithChildren<FormFieldProps>>> = Object.assign({}, {
  color: ColorField,
  file: FileField,
  markdown: MarkdownField,
  tags: TagsField,
  metadata: MetadataField,
  layout: LayoutField,
  astonish_email_template_select :AstonishEmailTemplateSelectField,
}, baseFields)

export const defaultValues: Record<string, any> = Object.assign({}, {
  color: {
    color: ''
  },
  file: null,
  markdown: '',
  tags: [],
  metadata: {},
  astonish_email_template_select: '',
}, baseDefaultValues)

export default fields